<template>
  <div>
    <!-- Heading -->
    <component
      :is="value.meta.headingLevel || 'h1'"
      class="pigeondoc__heading node__title"
      style="padding-top: 1rem; font-size: 3rem; text-align: center"
    >
      <span v-html="value.content.heading"></span>
    </component>

    <!-- Subheading -->
    <component
      v-if="value.content.subheading"
      :is="value.meta.headingLevel || 'h2'"
      class="pigeondoc__heading node__title"
      style="padding-top: 0rem; font-size: 2rem; text-align: center"
    >
      <span v-html="value.content.subheading"></span>
    </component>

    <!-- Date -->
    <component
      v-if="value.content.date"
      :is="value.meta.headingLevel || 'h2'"
      class="pigeondoc__heading node__title"
      style="padding-top: 0rem; font-size: 1.3rem; text-align: center"
    >
      <span v-html="formatDate(value.content.date)"></span>
    </component>
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'TitlePageNodeDisplay',
  props: {
    value: PigeonDocNodeModel,
    isICCS: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleDateString('en-GB');
    },
  },
};
</script>
